import { render } from "./LogoRwc.vue?vue&type=template&id=5ed33552"
import script from "./LogoRwc.vue?vue&type=script&lang=js"
export * from "./LogoRwc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__